import type { Picture } from './common'
import type { PostType } from './post'
import type { StoryStatus } from './story'

export enum Gender {
	FEMALE = 'FEMALE',
	MALE = 'MALE',
}

export interface UserDecorations {
	sponsor?: Sponsor
}

export interface Sponsor {
	picUrl: string
	themes?: SponsorThemes
}

export interface SponsorThemes {
	dark: Picture
}

export interface RefRemark {
	type: PostType
	refId: string
}

export interface Decorations {
	sponsor: Sponsor
}

export interface StatsCount {
	topicSubscribed: number
	topicCreated: number
	followedCount: number
	followingCount: number
	highlightedPersonalUpdates: number
	liked: number
	respectedCount: number
}

export interface Preferences {
	autoPlayVideo: boolean
	topicTagGuideOn: boolean
	dailyNotificationOn: boolean
	followedNotificationOn: boolean
	subscribeWeatherForecast: boolean
	privateTopicSubscribe: boolean
	undiscoverableByPhoneNumber: boolean
	saveDataUsageMode: boolean
	topicPushSettings: string
	debugLogOn: boolean
	env: string
	syncCommentToPersonalActivity: boolean
	repostWithComment: boolean
	enablePrivateChat: boolean
	blockStrangerPoke: boolean
	enablePictureWatermark: boolean
	enableOperationPush: boolean
	enableChatSound: boolean
	replyNotificationAllowGroup: string
	likeNotificationOn: boolean
	respectNotificationOn: boolean
	mentionNotificationOn: boolean
	liveNotificationOn: boolean
	openMessageTabOnLaunch: boolean
	tabOnLaunch: string
	hideSubscribeTab?: any
	undiscoverableByWeiboUser?: any
	paidMarket?: any
	followingUpdatesSortBy: string
	personalizedRecommendationOn: boolean
}

export type School = {}

export interface SponsorIcon {
	type: string
	picture: Picture
}

export interface AvatarSelection {
	title: string
	link: string
}

export interface RestrictedAvatarChange {
	nextChangeDate: string
	limits: number
}

export interface RestrictedNameChange {
	nextChangeDate: string
	limits: number
}

export interface BackgroundImage {
	picUrl: string
}

export interface LatestVisitor {
	id: string
	username: string
	screenName: string
	createdAt: string
	updatedAt: string
	isVerified: boolean
	verifyMessage: string
	briefIntro: string
	avatarImage: Picture
	decorations: Decorations
	profileImageUrl: string
	statsCount: StatsCount
	isBannedForever: boolean
	isSponsor: boolean
	backgroundImage: BackgroundImage
	bio: string
	gender: string
	city: string
	country: string
	province: string
}

export interface ProfileVisitInfo {
	todayCount: number
	latestVisitor: LatestVisitor
}

export interface User {
	id: string
	username: string
	screenName: string
	createdAt: string
	updatedAt: string
	isVerified: boolean
	verifyMessage: string
	briefIntro: string
	avatarImage: Picture
	decorations?: UserDecorations
	profileImageUrl: string
	statsCount: StatsCount
	isBannedForever?: boolean
	isSponsor: boolean
	industry: string
	zodiac: string
	sponsorExpiresAt?: string
	backgroundImage?: Picture
	backgroundMaskColor?: string
	bio?: string
	gender?: Gender
	city?: string
	country?: string
	province?: string
	following?: boolean
	refRemark?: RefRemark
	storyStatus?: StoryStatus
	trailingIcons?: TrailingIcon[]
	ref?: 'FOLLOWINGS_FEED_FOLLOW_SECTION' | 'REPOST_POST'
	profileTags?: ProfileTag[]
}

export interface ProfileTag {
	text: string
	type: string
	picUrl?: string
}

export interface TrailingIcon extends Picture {
	url: string
}
